import { render, staticRenderFns } from "./CitizenPassportList.vue?vue&type=template&id=6e65a83f&scoped=true&"
import script from "./CitizenPassportList.vue?vue&type=script&lang=ts&"
export * from "./CitizenPassportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e65a83f",
  null
  
)

export default component.exports